<template>
  <div class="product-list">
    <Toolbar :handle-add="addHandler" v-if="userHasAccess('product_edit')"/>

    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12>
          <h1><v-icon large>mdi-purse</v-icon>{{$t('qualitycheck.product.products')}}</h1>
        </v-flex>
        <v-flex lg12>
          <DataFilter :handle-filter="onSendFilter" :handle-reset="resetFilter">
            <ProductFilterForm
              ref="filterForm"
              :values="filters"
              slot="filter"
            />
          </DataFilter>

          <br />

          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="items"
  :items-per-page.sync="options.itemsPerPage"
:footer-props="footer"
            :loading="isLoading"
            :loading-text="$t('global.loading')"
            :options.sync="options"
            :server-items-length="totalItems"
            class="elevation-1"
            item-key="@id"
            @update:options="onUpdateOptions"
            @click:row="showHandler"
@contextmenu:row="showHandlerExt"
          >
                <template slot="item.startAssembly" slot-scope="{ item }">
                  {{ formatDate(item['startAssembly'], 'long') }}
                </template>
                <template slot="item.endAssembly" slot-scope="{ item }">
                  {{ formatDate(item['endAssembly'], 'long') }}
                </template>

            <ActionCell
              slot="item.action"
              slot-scope="props"
              :handle-show="() => showHandler(props.item)"
            ></ActionCell>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ListMixin from '../../mixins/ListMixin';
import ActionCell from '../../components/ActionCell';
import ProductFilterForm from '../../components/product/Filter';
import DataFilter from '../../components/DataFilter';
import Toolbar from '../../components/Toolbar';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'ProductList',
  servicePrefix: 'Product',
  mixins: [ListMixin,AccessMixin],
  components: {
    Toolbar,
    ActionCell,
    ProductFilterForm,
    DataFilter
  },
  data() {
    return {
      headers: [
        { text: this.$t('qualitycheck.product.name'), value: 'name' },
        { text: this.$t('qualitycheck.product.customer'), value: 'customer.name' },
        { text: this.$t('qualitycheck.product.statu'), value: 'status.name' },
        { text: this.$t('qualitycheck.product.location'), value: 'location' },
        { text: this.$t('qualitycheck.product.type'), value: 'type' },
        { text: this.$t('qualitycheck.product.typevalue'), value: 'valueType' },
        { text: this.$t('qualitycheck.product.userassembly'), value: 'userAssembly.login' },
        { text: this.$t('qualitycheck.product.startassembly'), value: 'startAssembly' },
        { text: this.$t('qualitycheck.product.endassembly'), value: 'endAssembly' },
        {
          text: this.$t('global.actions'),
          value: 'action',
          sortable: false
        }
      ],
      selected: [],
footer: {
  'itemsPerPageText': "",
},
      options: {sortBy : ['id'], sortDesc : [true]}
    };
  },
  computed: {
    ...mapGetters('product', {
      items: 'list'
    }),
    ...mapFields('product', {
      deletedItem: 'deleted',
      error: 'error',
      isLoading: 'isLoading',
      resetList: 'resetList',
      totalItems: 'totalItems',
      view: 'view'
    })
  },
  methods: {
    ...mapActions('product', {
      getPage: 'fetchAll',
      deleteItem: 'del'
    }),

  }
};
</script>
